// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__M8Clb","name":"styles_name__gw0fV"};